'use strict';

var logLevels = ["error", "warn", "info", "http", "verbose", "debug", "silly"];

function configureLogger() {
  return logLevels.reduce(function (configuredLogger, logLevel) {
    configuredLogger[logLevel] = function () {};
    return configuredLogger;
  }, {});
}

module.exports = configureLogger;
